<template>
  <Tabs value="line">
    <TabPane label="进度曲线" name="line">
      <div id="line"></div>
    </TabPane>
    <TabPane label="进度柱状图" name="bar">
      <progress-bar></progress-bar>
    </TabPane>
  </Tabs>
</template>

<script>
import echarts from 'echarts'
import { ListProgress } from '@/api/stat'
import ProgressBar from './ProgressBar'

export default {
  name: 'progress-stat',
  created: function () {
    this.init()
  },
  components: {
    'progress-bar': ProgressBar
  },
  methods: {
    init: function () {
      const id = this.$route.params.id
      ListProgress(id).then(async res => {
        this.drawProgress(res)
      })
    },
    drawProgress: function (res) {
      var opts = {
        width: 'auto',
        height: (document.documentElement.clientHeight - 200) + 'px'
      }
      this.charts = echarts.init(document.getElementById('line'), 'light', opts)
      this.charts.setOption({
        title: {
          text: '各中心堆积进度曲线',
          x: 'left'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 10,
          top: 30,
          bottom: 20,
          data: res.sites
        },
        grid: {
          left: '20%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100
          },
          {
            type: 'inside',
            realtime: true,
            start: 0,
            end: 100
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            onZero: false
          },
          data: res.dates
        },
        yAxis: {
          type: 'value'
        },
        series: res.series
      })
    }
  }
}
</script>
